module.exports = __webpack_public_path__ + "img/钟表-8.374aa349.png";